import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const ADMIN_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/admin';

const baseQuery = fetchBaseQuery({
  baseUrl: ADMIN_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('token');
    if (token) headers.set('Authorization', `Bearer ${token}`);
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // ✅ Handle errors globally
  if (result.error) {
    const status = result.error.status;

    // 401 — Login pe redirect
    if (status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    // 403 — Access denied
    else if (status === 403) {
      window.location.href = '/error?code=403';
    }

    // 500, 502, 503 — Server error
    else if (typeof status === 'number' && status >= 500) {
      window.location.href = `/error?code=${status}`;
    }

    // Network error
    else if (status === 'FETCH_ERROR') {
      window.location.href = '/error?code=network';
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Auth', 'Product', 'Category', 'Banner', 'Order', 'Customer', 'Review', 'Settings'],
  endpoints: () => ({}),
});